import { render, staticRenderFns } from "./create-business.component.html?vue&type=template&id=345f7d64&scoped=true&"
import script from "./create-business.component.ts?vue&type=script&lang=ts&"
export * from "./create-business.component.ts?vue&type=script&lang=ts&"
import style0 from "./create-business.component.scss?vue&type=style&index=0&id=345f7d64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345f7d64",
  null
  
)

export default component.exports